export const English = {
	usage_count: "Usage Count",
	normal: "Normal",
	qr: "QR",
	general: "General",
	total_leave_parkings: "Total Leave Parkings",
	cars_services: "Cars Services",
	total_zone: "Total Zone",
	total_parking: "Totla Parking",
	total_quick_valet: "Total Quick Valet",
	client: "Client",
	generally: "Generally",
	total_clients: "Total Clients",
	total_income: "Totla Income",
	total_drivers: "Total Drivers",
	average_service_time: "Average Service Time",
	zone_name: "Zone Name",
	number_of_cars: "Number Of Cars",
	total_earning: "Total Earning",
	staf_dirvers_reports: "Staff & Drivers Reports",
	staff: "Staff",
	zones_report: "Zones Report",
	qr_code: "QR Code",
	qr_code_group: "QR Code Group",
	qr_parking: "QR Parking",
	qr_code_number: "QR Code Number",
	login_number: "Login Number",
	qr_code_grouping: "QR Code Grouping",
	qr_code_valet: "QR Code Valet",
	one_time_price: "One Time Price",
	leave: "Leave",
	ready: "Ready",
	ready_for_pickup: "Ready For Pickup",
	there_are_no_data: "There are no data",
	effective_date: "Effective Date",
	increment: "Increment",
	previous_requests: "Previous requests",
	allowances: "Allowances",
	allowances_hr: "Allowances HR",
	allowance_name: "Allowance Name",
	has_allowances: "Has Allowances",
	assign: "Assign",
	reassign: "Re-Assign",
	assign_allowances: "Assign Allowances",
	assign_date: "Assign Date",
	licence_number: "Licence Number",
	licence: "Licence",
	licence_image: "Licence Image",
	number_of_available_parking: "Number of available Parking",
	assigned_staff: "Assigned Staff",
	temporary_zone: "Temporary Zone",
	price_per: "Price per",
	floor: "Floor",
	start_time: "Start Time",
	end_time: "End Time",
	notifications: "Notifications",
	government: "Government",
	assign_employee: "Assign Employee",
	no_of_students: "No of Students",
	fees: "Fees",
	staff_management: "Staff Management",
	staff_managment: "Staff Management",
	zones_managment: "Zones Management",
	zones_management: "Zones Management",
	parking: "Parking",
	driver: "Driver",
	car_image: "Car Image",
	parking_movement: "Parking Movement",
	parking_slots: "Parking Slots",
	parking_slot: "Parking Slot",
	vehicle_number: "Vehicle Number",
	vehicle_color: "Vehicle Color",
	vehicle_images: "Vehicle Images",
	entry_time: "Entry Time",
	exit_time: "Exit Time",
	total_parking_duration: "Total Parking Duration",
	assigned_driver: "Assigned Driver",
	qr_code: "QR Code",
	drivers_managment: "Drivers Managment",
	drivers_management: "Drivers Management",
	drivers: "Drivers",
	reports: "Reports",
	push_notification: "Push Notification",
	join_card: "Join Card",
	boy: "Boy",
	girl: "Girl",
	hall_break: "Hall Break",
	break: "Break",
	break_duration: "Break Duration",
	supervisors_type: "Supervisors Type",
	none: "None",
	time_in_minutes: "Time in minutes",
	after_number_of_classes: "After Which Classes",
	fee: "Fee",
	bank: "Bank",
	passport_no: "Passport No",
	employee_letters: "Employee Letters",
	employer_name: "Employer Name",
	hr_name: "Hr Name",
	passport_expiry_date: "Passport Expiry Date",
	benefits: "Benefits",
	date_of_join: "Date of Join",
	personal_informations: "Personal Informations ",
	bonus: "Bonus",
	annual: "Annual",
	attendance: "Attendance",
	attendance_hr: "Attendance HR",
	admin_updated_successfully: "Admin Updated Successfully",
	provision: "Provision",
	track_id: "Track ID",
	track: "Track",
	tran_id: "Tran ID",
	date: "Date",
	type: "Type",
	paid: "Paid",
	not_paid: "Not Paid",
	indemnity: "Indemnity",
	test_appointment: "Test Appointment",
	contract_no: "Contract No",
	illustration: "Illustration",
	package_price: "Package Price",
	day_price: "Day Price",
	week_price: "Week Price",
	month_price: "Month Price",
	start_day: "Start Day",
	booking: "Booking",
	end_day: "End Day",
	package_num: "Package Num",
	company_projects: "Company Projects",
	existing_projects: "Existing Projects",
	hosting_projects: "Hosting Projects",
	hosting: "Hosting",
	apply_filter: "Apply Filter",
	clear_filter: "Clear Filter",
	filter: "Filter",
	server: "Server",
	leave_balance: "Leave Balance",
	on_vaction: "On Vacation",
	vacation_history: "Vacation History",
	history: "History",
	leads: "Leads",
	all: "All",
	employees_on_vacation: "Employees on Vacation",
	cancellation_of_resignation: "Cancellation of resignation",
	notice_period: "Notice Period",
	resignation: "Resignation",
	start_resignation_date: "Start Resignation Date",
	end_resignation_date: "End Resignation Date",
	lead_name: "Lead Name",
	reference: "Reference",
	revenues: "Revenues",
	year: "Year",
	year_revenues: "Year Revenues",
	year_expenses: "Year Expenses",
	custody: "Custody",
	hour: "Hour",
	day: "Day",
	event_start_date: "Event Start Date",
	event_end_date: "Event End Date",
	event_start_time: "Event Start Time",
	event_end_time: "Event End Time",
	alert_time: "Alert Time",
	weddings: "Weddings",
	private_events: "Private Events",
	seasonal_events: "Seasonal Events",
	events_schedule: "Events Schedule",
	expenses: "Expenses",
	financial: "Financial",
	client_email: "Client Email",
	contract_date: "Contract Date",
	upload_contract: "Upload Contract",
	upload_image: "Upload Image",
	client_civil_id: "Client Civil Id",
	att_alert: "Please Enter Two Photos",
	from_front: "From Front",
	from_back: "From Back",
	back: "Back",
	payment_link: "Payment Link",
	profits: "Profits",
	payment_start_date: "Payment Start Date",
	freez: "Freez",
	allowances_options: "Allowances Options",
	allowances_in_vacations: "Allowances in Vacations",
	allowances_in_sick_leave: "Allowances in Sick Leave",
	allowances_not_in_vacations: "Allowances Not in Vacations",
	allowances_not_in_sick_leave: "Allowances Not in Sick Leave",
	excluded_employees_from_setting: "Excluded Employees From Setting",
	projects: "Projects",
	loans: "Loans",
	loan: "Loan",
	installments: "Installments",
	remaining_installment: "Remaining Installment",
	remaining: "Remaining",
	pos: "POS",
	number_of_employees: "Number Of Employees",
	no_of_installments: "No. of Installments",
	no_of_payments_made: "No. of Payments Made",
	effective_users: "Effective Users",
	effective_user: "Effective User",
	replace_employee: "Replace Employee",
	has_loans: "Has Loans",
	loans_history: "Loans History",
	basic_salary: "Basic Salary",
	deduction: "Deduction",
	note: "Note",
	commission: "Commission",
	termination: "Termination",
	end_of_service: "End of Service",
	organization: "Organization",
	personal_email: "Personal Email",
	company_email: "Company Email",
	allowances_setting: "Allowances Setting",
	company: "Company",
	unpaid_vacation: "Unpaid Vacation",
	loan_installment: "Loan Installment",
	after: "after",
	payroll_salary: "Payroll Salary",
	salary_slip: "Salary Slip",
	project: "Project",
	project_name: "Project Name",
	client_name: "Client Name",
	employee_name: "Employee Name",
	client_phone: "Client Phone",
	emergency_leave: "Emergency Leave",
	annual_leave: "Annual Leave",
	reason: "Reason",
	parent: "Parent",
	student: "Student",
	platform: "Platform",
	department: "Department",
	departments: "Departments",
	maintaince: "Maintaince",
	delete_date: "Delete Date",
	maintaince_start_date: "Maintaince Start Date",
	maintaince_end_date: "Maintaince End Date",
	assets: "Assets",
	salary: "Salary",
	salaries: "Salaries",
	employee: "Employee",
	employees: "Employees",
	request_sick_leave: "has made requests for sick leave with",
	request_salary_certificate: "has made request to issue salary certificate",
	is_requesting: "is requesting",
	for: "for",
	days: "Days",
	quick_valet: "Quick Valet",
	brand_model: "Brand Model",
	quick_valet_price: "Quick Valet Price",
	choiceـshowroom: "Choice Showroom",
	freeze: "Freeze",
	dashboard: "Dashboard",
	admins: "Admins",
	admin: "Admin",
	rules: "Rules",
	users: "Users",
	user: "User",
	categories: "Categories",
	category: "Category",
	category_name: "Category Name",
	vacation: "Vacation",
	vacations: "Vacations",
	accrued_leave: "Accrued Leave",
	sick: "Sick",
	sick_leave: "Sick Leave",
	is_sick: "Is Sick",
	sick_history: "Sick History",
	sub_categories: "SubCategories",
	sub_category: "SubCategory",
	brands: "Brands",
	variant: "Variant",
	dynamic_variant: "Dynamic Variant",
	products: "Products",
	products_sub: "Products",
	departure_day: "Departure Day",
	return_day: "Return Day",
	print: "Print",
	product: "Product",
	digital_products: "Digital Products",
	item_no: "Item No",
	item: "Item",
	items: "Items",
	barcode: "Barcode",
	product_name: "Product Name",
	reports: "Reports",
	notification: "Notification",
	time_slot: "Time Slot",
	times: "Times",
	banners: "Banners",
	news: "News",
	new: "New",
	website_banners: "Website Banners",
	members: "Members",
	ad_screen: "Ad Screen",
	job: "Job",
	job_title: "Job Title",
	works_hours: "Works Hours",
	works_day: "Works Day",
	control: "Control",
	contact_us: "Contact Us",
	setting: "Setting",
	delivery: "Delivery",
	entry_tiem: "Entry Tiem",
	social_media: "Social Media",
	social: "Social Media",
	website: "Website",
	currency: "Currency",
	pay: "Pay",
	pending: "Pending",
	prepare_car: "Prepare Car",
	payment: "Payment",
	payment_type: "Payment Type",
	pages: "Pages",
	total_categories: "Total Categories",
	total_sub_categories: "Total Sub Categories",
	total_brands: "Total Brands",
	total_admins: "Total Admins",
	gmail: "Gmail",
	total_activities_and_events: "Total Activities and Events",
	total_board_of_directors: "Total Board Of Directors",
	total_branches_and_markets: "Total Branches and Markets",
	total_news: "Total News",
	total_offers: "Total Offers",
	total_users: "Total Users",
	on_the_way: "On the Way",
	canceled: "Canceled",
	delivered: "Delivered",
	shipped: "Shipped",
	process: "Process",
	ordered: "Ordered",
	total_sales: "Total Sales",
	total_salary: "Total Salary",
	total_salaries: "Total Salaries",
	sales: "Sales",
	daily: "Daily",
	add_admin: "Add Admin",
	add_admins: "Add Admins",
	name: "Name",
	first_name: "First Name",
	last_name: "Last Name",
	email: "Email",
	diwans: "Diwans",
	shareholders: "Shareholders",
	import: "Import",
	shareholders_requests: "Shareholders Requests",
	requests: "Requests",
	attachments: "Attachments",
	number_of_people: "Number of People",
	people: "People",
	number_of_days: "Number of Days",
	membership_number: "Membership Number",
	address: "Address",
	address_link: "Address Link",
	user_name: "User Name",
	password: "Password",
	new_password: "New Password",
	confirm_password: "Confirm Password",
	change_password: "Change Password",
	phone: "Phone",
	country_code: "Country Code",
	permissions: "Permissions",
	status: "Status",
	action: "Action",
	rule: "Rule",
	full_address: "Full Address",
	full_permissions: "Full Permissions",
	full_time: "Full Time",
	part_time: "Part Time",
	some_permissions: "Some Permissions",
	civil_id: "Civil ID",
	employee_id: "Employee ID",
	box_number: "Box Number",
	family_card: "Family Card",
	no_permissions: "No Permissions",
	shareholder_code_number: "Shareholder Code Number",
	read_only: "Read Only",
	edit: "Edit",
	delete: "Delete",
	search_by: "Search by",
	profile: "Profile",
	logout: "LogOut",
	cancel: "Cancel",
	submit: "Submit",
	add: "Add",
	view: "View",
	select: "Select",
	deleted: "Deleted",
	next: "Next",
	upload_image_admin: "Upload Image (License/Civil Id)",
	previous: "Previous",
	go_to_page: "Go to Page",
	page: "Page",
	of: "of",
	add_categories: "Add Categories",
	active: "Active",
	not_active: "Not Active",
	image: "Image",
	month: "Month",
	remove: "Remove",
	assigned_products: "Assigned Products",
	remove_image: "Remove Image",
	deactive: "Deactive",
	english: "English",
	arabic: "Arabic",
	category_image: "Category Image",
	close: " Close",
	price: "Price",
	in_stock: "In Stock",
	english_title: "English Title",
	english_name: "English Name",
	arabic_title: "Arabic Title",
	arabic_name: "Arabic Name",
	english_description: "English Description",
	arabic_description: "Arabic Description",
	description: "Description",
	activities: "Activities",
	activity: "Activity",
	branches_and_markets: "Branches and Markets",
	code: "Code",
	cost: "Cost",
	quantity: "Quantity",
	weight: "Weight",
	offer_price: "Offer Price",
	best_seller: "Best Seller",
	new_in: "New In",
	offer: "Offer",
	offers: "Offers",
	images: "Images",
	create: "Create",
	types_by_english: "Types by English",
	types_by_arabic: "Types by Arabic",
	add_new_value: "Add New Value",
	chosse: "Chosse",
	employee_credentials: "Employee Credentials",
	has_amount: "Has Amount",
	amount: "Amount",
	available_amount: "Available Amount",
	kwd: "KWD",
	payment_method: "Payment Method",
	total_price: "Total Price",
	sub_price: "Sub Price",
	total: "Total",
	customer_name: "Customer Name",
	exist_user: "Exist User",
	new_user: "New User",
	search: "Search",
	order_day: "Order Day",
	from: "From",
	to: "To",
	coupon: "Coupon",
	verified: "Verified",
	updated_successfully: "Updated Successfully",
	updated_status_successfully: "Updated Status Successfully",
	profile_updated_successfully: "Profile Updated Successfully",
	banners_updated_successfully: "Banners Updated Successfully",
	banners_added_successfully: "Banners Added Successfully",
	added_successfully: "Added Successfully",
	apply: "Apply",
	enter: "Enter",
	add_new_product: "Add New Product",
	date_range: "Date Range",
	export: "Export",
	visa: "Visa",
	cash: "Cash",
	approved: "Approved",
	rejected: "Rejected",
	approve: "Approve",
	reject: "Reject",
	salary_certificate: "Salary Certificate",
	end_date: "End Date",
	start_date: "Start Date",
	expiry_date: "Expiry Date",
	nationality: "Nationality",
	max_usage: "Max Usage",
	count_usage: "Count Usage",
	percentage: "Percentage",
	fixed: "Fixed",
	net_profit: "Net Profit",
	or: "Or",
	serial_number: "Serial Number",
	serial_image: "Serial Image",
	title: "Title",
	message: "Message",
	send: "Send",
	delete_message:
		"Kindly note that this action can`t be undone and the details will get deleted.",
	details: "Details",
	welcome_back: "Welcome Back",
	sign_text: "Sign in by entering information below",
	text: "Very Good Works are Waiting for you",
	sign_in: "Sign In",
	login: "Login",
	specific_block: "Specific Block",
	capacity: "Capacity",
	interval: "Interval",
	open: "Open",
	rate: "Rate",
	country_name: "Country Name",
	country: "Country",
	banner: "Banner",
	link: "Link",
	ad: "Ad",
	add_new_screen: "Add New Screen",
	website_title: "Website Title",
	website_logo: "Website Logo",
	mobile_logo: "Mobile Logo",
	dashboard_logo: "Dashboard Logo",
	color: "Color",
	label_color: "Label Color",
	possible_delivery: "Possible Delivery",
	cash_in_delivery_fees: "Cash in Delivery Fees",
	shipping_fee: "Shipping Fee",
	price_per_kg: "Price per Kg",
	type_of_area: "Type of Area",
	all_area: "All Area",
	per_area: "Per Area",
	delivery_fees: "Delivery Fees",
	facebook: "Facebook",
	snapchat: "Snapchat",
	instagram: "Instagram",
	whatsapp: "Whatsapp",
	twitter: "Twitter",
	with: "with",
	and: "and",
	linked_in: "Linked In",
	telegram: "Telegram",
	tiktok: "Tiktok",
	app_store: "App Store",
	play_store: "Play Store",
	call_us: "Call Us",
	iban: "Iban",
	about: "About",
	cms: "CMS",
	blogs: "Blogs",
	gallery: "Gallery",
	faqs: "FAQs",
	privacy: "Privacy",
	talabat: "Talabat",
	address_name: "Address Name",
	block: "Block",
	street: "Street",
	area: "Area",
	first: "First",
	avenue: "Avenue",
	building_number: "Building Number",
	floor_number: "Floor Number",
	office_number: "Office Number",
	house_number: "House Number",
	apt_number: "Apt Number",
	other_instructions: "Other Instructions",
	delivery_day: "Delivery Day",
	time: "Time",
	confirm_added: "Confirm Added",
	added: "Added",
	confirm_des: "You can add another product by change some information",
	add_more_products: "Add More Same Product",
	reference_id: "Reference Id",
	invoice_id: "Invoice ID",
	increase: "Increase",
	holiday: "Holiday",
	login_details: "Login Details",
	human_resources: "Human Resources",
	post_date: "Post Date",
	createdAt: "CreatedAt",
	order_id: "Order Id",
	static_pages: "Static Pages",
	field_required: "This Field is required",
	ordered_successfully: "Ordered Successfully",
	you_tube: "Youtube",
	successfully: "Successfully",
	ordered_failed: "Ordered Failed",
	failed_msg: "The payment process is not complete",
	back_home: "Back to Home",
	knet: "Knet",
	bidding_management: "Bidding Management",
	app_commission_management: "App Commission Management",
	wallet_management: "Wallet Management",
	brand_management: "Brand Management",
	time_management: "Time Management",
	location: "Location",
	january: "January",
	february: "February",
	march: "March",
	april: "April",
	may: "May",
	june: "June",
	july: "July",
	august: "August",
	september: "September",
	october: "October",
	november: "November",
	december: "December",
	not_started: "Not Started",
	daily_indemnity: "Daily Indemnity",
	exceeding_years_indemnity: "Exceeding Years Indemnity",
	first5YearsIndemnity: "First 5 Years Indemnity",
	monthly_indemnity: "Monthly Indemnity",
	paid_leave_balance_amount: "Paid Leave Balance Amount",
	leave: "Leave",
	total_indemnity: "Total Indemnity",
	civil_id_status: "Civil Id Status",
	passport_status: "Passport Status",
	residency_status: "Residency Status",
	valid: "Valid",
	expired: "Expired",
	admin_management: "Admin Management",
	recent_transactions: "Recent Transactions",
	orders: "Orders",
	admin_settings: "Admin Settings",
	branches: "Branches",
	branch: "Branch",
	branch_no: "Branch No",
	branch_manager: "Branch Manager",
	work_shift: "Work Shift",
	gates_no: "No Of Gates",
	gate_no: "Gate Number",
	branch_name: "Branch Name",
	branch_details: "Branch Details",
	branch_id: "Branch ID",
	shift: "Shift",
	facilities: "Facilities",
	halls: "Halls",
	job_titles: "Job Titles",
	roles: "Roles",
	role: "Role",
	hr_plans: "HR Plans",
	hr_letters: "HR Letters",
	organization_chart: "Organization Chart",
	teacher_management: "Teacher Management",
	zones: "Zones",
	executive_plan: "Executive Plan",
	teachers: "Teachers",
	pos_management: "POS Management",
	pos: "POS",
	pos_reports: "POS Reports",
	pos_reports_sub: "POS Reports",
	operation_management: "Operation Management",
	operations: "Operations",
	vehicles: "Vehicles",
	support_services: "Support Services",
	monitoring: "Monitoring",
	medical_care: "Medical Care",
	program_management: "Program Management",
	supervisors: "Supervisors",
	education: "Education",
	entertainment: "Entertainment",
	groups: "Groups",
	night_revision: "Night Revision",
	early_leave_emergency: "Early Leave & Emergency",
	contacts_crm: "Contacts CRM",
	variants: "Variants",
	add_on_group: "Add On Group",
	coupons: "Coupons",
	inventory: "Inventory",
	stocks: "Stocks",
	purchases: "Purchases",
	warehouse: "Warehouse",
	sales_dashboard: "Sales Dashboard",
	complaints: "Complaints",
	email_tracking: "Email Tracking",
	contacts: "Contacts",
	referral: "Referral",
	campaign: "Campaign",
	deals: "Deals",
	crm: "CRM",
	suppliers: "Suppliers",
	chart_of_accounts: "Chart Of Accounts",
	financial_year: "Financial Year",
	company_logo: "Company Logo",
	work_shifts: "Work Shifts",
	contract_types: "Contract Types",
	request_types: "Request Types",
	settings: "Settings",
	sales_report: "Sales Report",
	purchase_report: "Purchase Report",
	products_report: "Products Report",
	suppliers_report: "Suppliers Report",
	attendance_report: "Attendance Report",
	salaries_report: "Salaries Report",
	documents: "Documents",
	alerts: "Alerts",
	units: "Units",
	unit: "Unit",
	department_name: "Department Name",
	unit_name: "Unit Name",
	department_manager: "Department Manager",
	no_of_units: "No. Of Units",
	no_of_employees: "No. Of Employees",
	unit_manager: "Unit Manager",
	facility: "Facility",
	facility_type: "Facility Type",
	facility_plan: "Facility Plan",
	scheduled_time: "Scheduled Time",
	assigned_branches: "Assigned Branches",
	owner: "Owner",
	legal_name: "Legal Name",
	authorised_signatory: "Authorised Signatory",
	establishment_date: "Establishment Date",
	fields_of_work: "Fields of Work ",
	fax_number: "Fax Number",
	year_days: "Year Days",
	license_number: "License Number",
	commercial_registration: "Commercial Registration",
	legal_office: "Legal Office ",
	save: "Save",
	select_all: "Select All",
	unselect_all: "Unselect All",
	hall: "Hall",
	hall_name: "Hall Name",
	hall_no: "Hall No",
	program_type: "Program Type",
	capacity_assumption: "Capacity Assumption",
	gender: "Gender",
	coach: "Coach",
	in_maintanence: "In Maintanence",
	time_from: "Time From",
	time_to: "Time To",
	number_of_classes: "Number of Classes",
	class: "Class",
	number: "Number",
	hall_details: "Hall Details",
	interval_between_classes: "Interval Between Classes",
	organization_color: "Organization Color",
	created_on: "Created On",
	Total_active_students: "Total Active Students",
	Available_programs_and_camps: "Available Programs and Camps",
	Available_Educational_Courses: "Available Educational Courses",
	Max: "Max",
	Words: "Words",
	Word: "Word",
	max_size: "Max Size",
	mbs: "MBs",
	num_of_images: "Number of Images",
	banner_image: "Banner Image",
	max_number: "Max Number",
	published: "Published",
	drafted: "Drafted",
	blog: "Blog",
	add_new_position: "Add New Position",
	position: "Position",
	position_applied: "Position Applied",
	positions: "Positions",
	optional: "Optional",
	for_hiring: "For Hiring",
	contact: "Contact",
	confirm: "Confirm",
	sales_email: "Sales Email",
	support_email: "Support Email",
	call_number: "Call Number",
	another_call_number: "Another Call Number",
	inquiry: "Inquiry",
	suggestion: "Suggestion",
	complaint: "Complaint",
	job_application: "Job Application",
	cv: "CV",
	subject: "Subject",
	assign_subject_to_hall: "Assign Subject to Hall",
	closed: "Closed",
	hall_type: "Hall Type",
	single: "Single",
	multi: "Multi",
	on_group: "On Group",
	group_product_name: "Group Product Name",
	accepted_years: "Accepted Years",
	platform_social_links: "Platform Social Links",
	whatsapp_link: "Whatsapp link",
	instagram_link: "Instagram Link",
	facebook_link: "Facebook link",
	iOS_download_link: "IOS Download link",
	android_download_link: "Android Download Link",
	terms_conditions: "Terms & Conditions",
	terms_privacy: "Terms & Privacy",
	programs: "Programs",
	program: "Program",
	subjects: "Subjects",
	education_type: "Education Type",
	grade: "Grade",
	grades: "Grades",
	program_name: "Program Name",
	multi_select: "Multi Select",
	choose: "Choose",
	at_home: "At Home",
	group_capacity: "Group Capacity",
	first_sub_group: "First Sub Group",
	second_sub_group: "Second Sub Group",
	supervisor_span: "Supervisor Span",
	at_center: "At Center",
	online: "Online",
	program_start_date: "Program Start Date",
	program_end_date: "Program End Date",
	foundation: "Foundation",
	curriculum: "Curriculum",
	group_settings: "Group Settings",
	program_classification: "Program Classification",
	group: "Group",
	private: "Private",
	age_group: "Age Group",
	programs_note:
		"If a student has reserved a program, it cannot be deleted. A program can only be deleted if it has no reservations.",
	subjects_note:
		"Subjects in the same category can't be in the same day for student.",
	program_details: "Program Details",
	group_name: "Group Name",
	coash: "Coash",
	enable_capacity_assumption: "Enable Capacity Assumption",
	hall_classification: "Hall Classification",
	gate_name: "Gate Name",
	assign_manager: "Assign Manager",
	allowance_time: "Allowance Time",
	contract_type: "Contract Type",
	duration: "Duration",
	payment_methods: "Payment Methods",
	lessons_frequency_week: "Lessons Frequency/Week",
	academic_qualifications: "Academic Qualifications",
	job_information: "Job Information",
	photo: "Photo",
	joining_date: "Joining Date",
	academic_degree: "Academic Degree",
	specialization: "Specialization",
	university: "University",
	teaching_certification: "Teaching Certification",
	years_of_experience: "Years of Experience",
	add_additional_skills: "Add Additional Skills",
	additional_licence: "Additional Licence",
	upload_max3: "Upload Max 3",
	upload_your_photo: "Upload your Photo",
	set_as_manager: "Set as Manager",
	yes: "Yes",
	no: "No",
	annual_vacation: "Annual Vacation",
	personal_info: "Personal Info",
	male: "Male",
	female: "Female",
	mixed: "Mixed",
	bachelors: "Bachelors",
	master: "Master",
	phd: "PHD",
	diploma: "Diploma",
	high_school: "High School",
	associate: "Associate",
	other: "Other",
	supervisor: "Supervisor",
	manager: "Manager",
	kuwait: "Kuwait",
	kwt: "Kuwait",
	british: "British",
	american: "American",
	draft: "Draft",
	e_commerce: "E-commerce",
	color_code: "Color Code",
	sku: "SKU",
	qty: "QTY",
	physical_product: "Physical Product",
	digital_product: "Digital Product",
	service_product: "Service Product",
	packages_product: "Packages Product",
	package_name: "Package Name",
	features: "Features",
	discount: "Discount",
	stock: "Stock",
	available_for_delivery: "Available for delivery",
	has_variant: "Has Variant",
	course_name: "Course Name",
	video_name: "Video Name",
	service_name: "Service Name",
	with_qty: "With QTY",
	free_of_qty: "Free of QTY",
	upload_video: "Upload Video",
	duration_of_video: "Duration of Video",
	number_of_videos: "Number Of Videos",
	zone_group: "Zone Group",
	zone_groups: "Zone Groups",
	zone: "Zone",
	zones_name: "Zones Name",
	number_of_semester: "Number Of Semester",
	name_of_semester: "Name Of Semester",
	academic_year: "Academic Year",
	start_year: "Start Year",
	finish_year: "Finish Year",
	semester_info: "Semester Info",
	choose_education_type: "Choose Education Type",
	semester_details: "Semester Details",
	semeseter: "Semester",
	semester: "Semester",
	exam_nights: "Exam Nights",
	final_revision: "Final Revision",
	teacher: "Teacher",
	availability_time: "Availability Time",
	teacher_info: "Teacher Info",
	owns_a_car: "Owns a Car",
	doesnot_own_a_car: "Doesn't Own a Car",
	wamd_number: "Wamd Number",
	availability_time_in_each_semester: "Availability Time in Each Semester",
};
